import { render, staticRenderFns } from "./TabSection.vue?vue&type=template&id=0ba1e044"
import script from "./TabSection.vue?vue&type=script&lang=js"
export * from "./TabSection.vue?vue&type=script&lang=js"
import style0 from "./TabSection.vue?vue&type=style&index=0&id=0ba1e044&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports